import styled from "styled-components";

export const ModalContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.black.default};
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.55);
  color: #fff;
  cursor: pointer;

  & svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.75);
  }
`;

export const TourIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  flex: 1;
`;

export const ErrorMessage = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin: 0;
  padding: 24px;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: ${16 / 16}rem;
  color: #fff;
`;
